import { Action, IOWidget, mk_widget, Pair } from 'widgets-for-react'
import React from 'react'

import Plyr from 'react-plyr'
import { ImageSize, CMSState } from '../../../../cms/blocks/types.gen'
import { getClassName } from '../../../../cms/blocks/utils.gen'
import { CookieSensitiveContentWrapper } from '../../../../cms/blocks/cookiebar.mod'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { WordPress } from '../../../../wordpress/wordpress_api'
import { getImageSize } from '../../../utils/extra_images.mod'
import { PublicSiteState } from '../../../../public_site.main.mod'

export type MediaBlockProps<extra_images> = {
  block_index: number
  kind_media: 'image' | 'video'
  image?: WordPress.Image
  image_alt?: string
  size?: ImageSize<extra_images>
  get_default_data_src: () => ImageSize<extra_images>
  get_default_data_srcset: () => Pair<ImageSize<extra_images>, string>[]
  video?: {
    url?: string
    id: string
    type: 'youtube' | 'vimeo' | 'video' | 'audio'
    width: string
    height: string
    frameBorder: string
    allowFullScreen: boolean
  }
  caption?: string
  useCookieBar: boolean
}

export type MediaBlockStyle = Partial<{
  block_classname: string
  inner_classname: string
  content_classname: string
  figure_classname: string
  media_classname: string
  image_classname: string
  placeholder_classname: string
  video_classname: string
  figcaption_classname: string
  caption_classname: string
  cookies_classname: string
  cookies_inner_classname: string
  cookies_text_classname: string
  cookies_clickable_classname: string
}>

export function MediaBlock<CustomBlockData, extra_images>(
  props: MediaBlockProps<extra_images>,
  options?: { style?: MediaBlockStyle; key?: string }
  ): (s:CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<CustomBlockData,extra_images, PublicSite_CustomPageData>>> {
    return (s: CMSState<CustomBlockData,extra_images, PublicSite_CustomPageData>) => (public_state:PublicSiteState) =>
    mk_widget({
      run: o => {
        return (
          <section
            className={getClassName(options, 'block_classname', 'container')}
            key={props && props.block_index ? props.block_index : 'media-block'}
          >
            <div className={getClassName(options, 'inner_classname', 'py-5')}>
              <div className={getClassName(options, 'content_classname', '')}>
                <figure className={getClassName(options, 'figure_classname', '')}>
                  {props.kind_media === 'image' ?
                    (props.image && <div className={getClassName(options, 'media_classname', '')}>
                        <img src={getImageSize<extra_images>(props.image, '1840w')}
                          className={getClassName(options, 'image_classname', 'w-100')}
                          alt={props.image_alt}
                          width="1840px"
                          height="1840px"
                           />
                      </div>
                  ) : (
                    props.kind_media === 'video' &&
                    props.video != undefined && (
                      <div className={getClassName(options, 'media_classname', 'text-center')}>
                        {props.useCookieBar ? (
                          <CookieSensitiveContentWrapper
                            options={{
                              style:
                                options && options.style
                                  ? {
                                      cookies_classname: options.style.cookies_classname,
                                      cookies_inner_classname: options.style.cookies_inner_classname,
                                      cookies_text_classname: options.style.cookies_text_classname,
                                      cookies_clickable_classname: options.style.cookies_clickable_classname
                                    }
                                  : undefined
                            }}
                            placeholder={
                              <>
                                Wijzig je <a href="#cookiesettings">cookievoorkeuren</a> om deze video te bekijken in Compleet of Beperkt.
                              </>
                            }
                          >
                            <Plyr type={props.video.type} width="100%" videoId={props.video.url} />
                          </CookieSensitiveContentWrapper>
                        ) : (
                          <Plyr type={props.video.type}  width="100%" videoId={props.video.url} />
                        )}
                      </div>
                    )
                  )}

                  {props.caption && (
                    <figcaption className={getClassName(options, 'figcaption_classname', '')}>
                      <div
                        className={getClassName(options, 'caption_classname', 'small text-secondary text-center mt-2')}
                        dangerouslySetInnerHTML={{ __html: props.caption }}
                      >
                      </div>
                    </figcaption>
                  )}
                </figure>
              </div>
            </div>
          </section>
        )
      }
    })
}



// WEBPACK FOOTER //
// ./Client/components/public_site/blocks/custom_blocks/widgets/mediaBlock.mod.tsx